import { useContext, useMemo, useState } from "react";
import { downloadCSV } from "../../../utils/utils";
import DownloadModal from "../../../modals/downloadModal";
import { MyContext } from "../../../MyContext/MyProvider";

const CSV = () => {
  const [isdownloadopen, setisdownloadopen] = useState(false);
  const columnOrder = ["Select", "entity_type", "text", "start", "end"];
  const { selectedEntities, findingsWithHighlight, toggleHighlight } =
    useContext(MyContext);

  const filteredFindings = useMemo(() => {
    return findingsWithHighlight.filter((finding) =>
      selectedEntities.includes(finding.entity_type)
    );
  }, [findingsWithHighlight, selectedEntities]);

  return (
    <>
      {filteredFindings.length ? (
        <div className="table-main d-flex w-100 gap-2">
          <div className="libraries-table">
            <table className="m-auto" id="data-table">
              <thead>
                <tr className="libraries-thead">
                  {columnOrder.map((key, index) => (
                    <th key={index}>
                      <div className="th-inner px-3">{key}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredFindings.map((finding) => (
                  <tr key={finding.id} className="libraries-tbody">
                    {columnOrder.map((key, index) => (
                      <td key={index} className="first-td">
                        <div className="td-inner px-3">
                          {key === "Select" ? (
                            <input
                              type="checkbox"
                              checked={finding.highlight}
                              onChange={() => toggleHighlight(finding.id)}
                            />
                          ) : (
                            finding[key]
                          )}
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <img
              src="../../../assets/icons/downloadCSV.png"
              alt="downloadCSV"
              onClick={downloadCSV}
              className="cursor-pointer"
            />
          </div>
        </div>
      ) : (
        <h2>No entities are selected</h2>
      )}

      <DownloadModal
        isdownloadopen={isdownloadopen}
        setisdownloadopen={setisdownloadopen}
      />
    </>
  );
};

export default CSV;
